export enum ContactPageProfileTabSectionId {
  PROFILE_INFO = 'profile-info',
  EVENTS = 'events',
  WISH_LIST = 'wish-list',
  PAST_GIFTS = 'past-gifts',
}